<div class="w-full flex justify-between items-center h-8">
    <div class="flex items-center gap-4">
        <div class="flex flex-col items-center justify-center">
            <button mat-icon-button class="toggle-sidebar-folded hidden lg:block" (click)="toggleSidebarFolded()">
                <mat-icon>menu</mat-icon>
            </button>

            <button mat-icon-button class="toggle-sidebar-opened block lg:hidden" (click)="toggleSidebarOpened()">
                <mat-icon>menu</mat-icon>
            </button>
        </div>
        <img class="h-8 w-8" [src]="logoUrl" />
    </div>

    <div>
        <button mat-icon-button [matMenuTriggerFor]="helpMenu" aria-label="Ajuda" matTooltip="Ajuda">
            <mat-icon [svgIcon]="'question-circle'"></mat-icon>
        </button>
        <mat-menu #helpMenu="matMenu" class="v2-menu">
            <button mat-menu-item (click)="openKb()">
                <mat-icon [svgIcon]="'question-circle'"></mat-icon>
                <span>Central de Ajuda</span>
            </button>
            @if (supportChatEnabled) {
            <button mat-menu-item (click)="openChat()">
                <mat-icon [svgIcon]="'comment-alt-message'"></mat-icon>
                <span>Chat com a vSaúde</span>
            </button>
            }
        </mat-menu>

        <button mat-icon-button [matMenuTriggerFor]="profileMenu">
            <mat-icon [svgIcon]="'user'"></mat-icon>
        </button>
        <mat-menu #profileMenu="matMenu" class="v2-menu">
            <button mat-menu-item routerLink="/v2/my-profile">
                <mat-icon [svgIcon]="'user'"></mat-icon>
                <span>Meu Perfil</span>
            </button>
            <button mat-menu-item (click)="logout()">
                <mat-icon [svgIcon]="'signout'"></mat-icon>
                <span>Fazer Logout</span>
            </button>
        </mat-menu>
    </div>
</div>
